import axios from 'axios'

const prefix = '/checkout'

export const getSingleCheckout = async (id) => {
  return await axios.get(`${prefix}/${id}`)
}
